/**
 * Component: Toggle
 * ------------------------------------------------------------------------------
 * A accessible _to trigger a toggle-able component with a window overlay.
 *
 * @namespace SearchBar
 *
 */
import log from 'salvo-lite/log'
import cssClasses from '../helpers/cssClasses'
import {on} from '../helpers/utils'

class SearchBar {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            selector: '[data-search-location="header"]',
            input: elem.querySelector('[data-search="input"]'),
            placeholder: elem.querySelector('[data-search="placeholder"]'),
            mainHeader: document.querySelector('[data-header-container]'),
            ...JSON.parse(elem.getAttribute('data-searchbar') || '{}')
        }
        this._settings.container = document.querySelector(this._settings.selector)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._setEventListeners()
    }

    /**
     * Set eventBus listeners.
     */
    _setEventListeners () {
        window.Frame.EventBus.listen('Toggle:searchTarget:open', () => {
            document.documentElement.classList.add('js-search-active')
        })

        window.Frame.EventBus.listen('Toggle:searchTarget:close', () => {
            document.documentElement.classList.remove('js-search-active')
        })

        on('keyup', this._settings.input, () => this._handleKeypressEvent())
        on('focus', this._settings.input, () => this._handleFocusEvent())
    }

    /**
     * Handle search input keyup event.
     */
    _handleKeypressEvent () {
        if (this._settings.input.value.length > 0) {
            this._settings.placeholder.classList.add(cssClasses.hidden)
            return
        }

        this._settings.placeholder.classList.remove(cssClasses.hidden)
    }

    /**
     * Handle search input focus event.
     * – Adds body class to hide Boost search suggestions when focussed.
     */
    _handleFocusEvent () {
        if (this._settings.selector === '[data-search-location="inline"]') {
            document.body.classList.add(cssClasses.searchHide)
            return
        }

        document.body.classList.remove(cssClasses.searchHide)
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SearchBar.js